import { createTheme } from '@mui/material/styles';
import { Components } from '@mui/material/styles/components';
import { ControllerTabColor } from '../../palette';
import { ControllerFont } from '../../fonts';

const theme = createTheme();

export const TabComponent: Components = {
  MuiTab: {
    styleOverrides: {
      root: {
        padding: theme.spacing(0.5, 1),
        color: String(ControllerTabColor.InactiveFg),
        ...ControllerFont.Body400R,
        // larger letter spacing when un-selected helps
        // to minimize horizontal jitter between toggles
        letterSpacing: 0.18,
        minHeight: 0,
        textTransform: 'none',
        '&.Mui-selected': {
          color: String(ControllerTabColor.ActiveFg),
          ...ControllerFont.Heading200B,
          letterSpacing: 0,
          // scaling text down when selected helps to
          // minimize horizontal jitter between toggles
          transform: 'scale(0.985, 1)',
        },
      },
    },
  },
};
